import type { RouteRecordRaw } from 'vue-router';

export const bankPartnerRoutes: Array<RouteRecordRaw> = [
  {
    name: 'BankPartners',
    path: 'bankpartners',
    component: () => import('@/views/private/bankPartner/ListBankPartners.vue'),
  },
  {
    props: true,
    name: 'BankPartner',
    path: 'instituicao-financeira/:id',
    component: () => import('@/views/private/bankPartner/[id].vue'),
  },
];
export const financialInstitution = bankPartnerRoutes;
